import { HttpMethod, HttpOption } from '@/utils/http-client'
import { LoanRequest, CancelLoanRequest, QueryLoanInfoRequest, loanReviewWequest } from '@/api/model/loan'

export class LoanAPIConstant {
    queryLoanPage = (data: LoanRequest): HttpOption => ({
        url: '/fundcloud/loan/query-loanPage',
        method: HttpMethod.POST,
        data
    })

    cancelLoan = (data: CancelLoanRequest): HttpOption => ({
        url: '/fundcloud/loan/cancelLoan',
        method: HttpMethod.POST,
        data
    })

    queryLoanInfo = (data: QueryLoanInfoRequest): HttpOption => ({
        url: '/fundcloud/loan/api/query-loanInfo',
        method: HttpMethod.POST,
        data
    })

    loanReview = (data: loanReviewWequest): HttpOption => ({
        url: '/fundcloud/loan/loanReview',
        method: HttpMethod.POST,
        data
    })
}
